import { dismissApp } from '@/shared/lib/app-bridge'
import { Button } from '@/shared/ui/button/button'

import styles from './error.module.scss'

type ErrorPageProps = {
    description?: string
    error?: string
    resetError?: () => void
    title?: string
}

const getMeaningfulValue = (value?: null | string) => {
    if (!value) {
        return null
    }

    return value.trim() ? value : null
}

export const ErrorPage = ({ title, description, resetError }: ErrorPageProps) => {
    // const router = useRouter()
    const searchQuery = globalThis.window === undefined ? '' : globalThis.location.search
    const searchParams = new URLSearchParams(searchQuery)
    const titleParameter = searchParams.get('title')
    const descriptionParameter = searchParams.get('description')

    const titleValue = getMeaningfulValue(title) ?? getMeaningfulValue(titleParameter) ?? 'Ошибка'
    const descriptionValue =
        getMeaningfulValue(description) ??
        getMeaningfulValue(descriptionParameter) ??
        'Неизвестная ошибка'

    const handleResetError = () => {
        resetError?.()

        // location.href на /error кладёт экран в историю браузера, back возвращает на него.
        // Если страница открыта первой, истории нет — закрываем WebView.
        // if (globalThis.history.length > 1) {
        //     router.history.back()

        //     return
        // }

        dismissApp()
    }

    return (
        <div className={styles.error}>
            <h1 className={styles.error__title}>{titleValue}</h1>
            <p className={styles.error__description}>{descriptionValue}</p>
            <Button
                className={styles.error__button}
                size='large'
                variant='primary'
                onClick={handleResetError}
            >
                Повторить
            </Button>
        </div>
    )
}
